import { WORD_NOUNS, WORD_PROPERTIES, WORD_CONNECTOR } from '../../editor/EditorTypes';

interface WordPaletteProps {
  selectedWord?: string;
  onSelectWord: (wordType: string) => void;
}

export function WordPalette({ selectedWord, onSelectWord }: WordPaletteProps) {
  return (
    <div className="word-palette">
      <h3>Words</h3>
      
      <div className="word-section">
        <h4>Connector</h4>
        <button
          className={`palette-item ${selectedWord === WORD_CONNECTOR ? 'selected' : ''}`}
          onClick={() => onSelectWord(WORD_CONNECTOR)}
        >
          IS
        </button>
      </div>

      <div className="word-section">
        <h4>Nouns</h4>
        <div className="palette-items">
          {WORD_NOUNS.map(type => (
            <button
              key={type}
              className={`palette-item ${selectedWord === type ? 'selected' : ''}`}
              onClick={() => onSelectWord(type)}
            >
              {type.replace('WORD_', '')}
            </button>
          ))}
        </div>
      </div>

      <div className="word-section">
        <h4>Properties</h4>
        <div className="palette-items">
          {WORD_PROPERTIES.map(type => (
            <button
              key={type}
              className={`palette-item ${selectedWord === type ? 'selected' : ''}`}
              onClick={() => onSelectWord(type)}
            >
              {type.replace('WORD_', '')}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
